import React, {useEffect, useRef, useState} from 'react';
import { useTable, useFilters, useFlexLayout, usePagination } from 'react-table';

import FilterDropDown from "../fitlerDropDown";

import { DynamicTable, TableWrapper, TableCell,TableHead } from "./index.style";

const PAGE_ADDITION = 15;

const InformationTable = ({columns, data}) => {
  const {
    getTableProps,
    headerGroups,
    page,
    prepareRow,
    getTableBodyProps,
    setPageSize,
  } = useTable(
    {
      columns,
      data,
      initialState: {pageIndex: 0, pageSize: 15},
    },
    useFilters,
    useFlexLayout,
    usePagination,
  );
  const table = useRef() as React.MutableRefObject<HTMLDivElement>;
  const [ pageSize, setPageSizeState ] = useState(10);

  useEffect(() => {
    const detectScrollBottom = () => {
      if(table.current.scrollHeight - (table.current.scrollTop + table.current.getBoundingClientRect().height) <= 0 && pageSize < data.length) {
        setPageSizeState(prevState => {
          setPageSize(prevState+PAGE_ADDITION);
          return prevState+PAGE_ADDITION;
        })
      }
    };

    if(table.current) {
      table.current.addEventListener('scroll', detectScrollBottom, false);
      return () => table.current.removeEventListener('scroll', detectScrollBottom);
    }
  },[]);

  return (
    <TableWrapper ref={table}>
      <DynamicTable {...getTableProps()}>
        <thead>
        {headerGroups.map((headerGroup,index) => (
          <tr {...headerGroup.getHeaderGroupProps()}>
            {headerGroup.headers.map(column => {
              return (
              <React.Fragment>
                <TableHead sub={index==1} {...column.getHeaderProps()}>
                  {column.render('Header')}
                  {column.filter != undefined &&
                  <FilterDropDown>
                    {column.render('Filter')}
                  </FilterDropDown>}
                </TableHead>
              </React.Fragment>
            )})}

          </tr>
        ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {page.map(row => {
            prepareRow(row);
            return (
              <tr {...row.getRowProps()}>
                {row.cells.map((cell,index) => {
                  return <TableCell odd={index%2 ==0} {...cell.getCellProps()}>
                    {cell.render('Cell')}
                  </TableCell>
                })}
              </tr>
            )
          })}
        </tbody>
      </DynamicTable>
    </TableWrapper>
  )
};
export default InformationTable